export default [
    {
        path: '/report',
        component: () => import('@/views/report')
    },   
    {
        path: '/report/course-sales-statistics',
        component: () => import('@/views/report/course-sales-statistics')
    }, 
    {
        path: '/report/adventure-mode-report',
        component: () => import('@/views/report/adventure-mode-report')
    }, 
    {
        path: '/report/school-assignment-report',
        component: () => import('@/views/report/school-assignment-report')
    }, 
    {
        path: '/report/promotion-code-report',
        component: () => import('@/views/report/promotion-code-report')
    },
    {
        path: '/report/activate-report',
        component: () => import('@/views/report/activate-report')
    },
    {
        path: '/report/teacher-activate-report',
        component: () => import('@/views/report/teacher-activate-report')
    },
    {
        path: '/report/studentLoginLog',
        component: () => import('@/views/report/studentLoginLog')
    },
    {
        path: '/report/emailLog',
        component: () => import('@/views/report/emailLog')
    }
]